module.exports = __webpack_public_path__ + "img/seckill2.4043e34b.png";